module.exports = __webpack_public_path__ + "img/枣庄中安旧机动车交易市场有限公司.b562f390.jpg";